import List from "@/components/list";

const Table = (args) => {
  const { listeners, props } = args;
  const handleInfo = listeners["handleInfo"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-message", "查看详情", () => handleInfo(vo.row), "userCheck:info"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => {
          return (
            <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
              <i class={item[0]} onClick={item[2]}></i>
            </el-tooltip>
          )
        })}
      </div>
    );
  };

  let AccountTableConfig = [
    {
      label: "核对管理主体",
      prop: "leaderTypeName",
      minWidth: "180",
    }, {
      label: "导入总数",
      prop: "userCheckNum",
      minWidth: "100",
    }, {
      label: "基础信息修改",
      prop: "userUpdateNum",
      minWidth: "100",
    }, {
      label: "人员新增",
      prop: "userAddNum",
      minWidth: "100",
    }, {
      label: "其他",
      prop: "userOtherNum",
      minWidth: "100",
    }, {
      label: "无更新",
      prop: "noUpdateNum",
      minWidth: "100",
    }, {
      label: "人员缺失",
      prop: "userMissNum",
      minWidth: "100",
    }, {
      label: "核对时间",
      prop: "createDate",
      minWidth: "160",
    }, {
      label: "状态",
      prop: "checkStatusName",
      minWidth: "100",
    }, {
      label: "操作人",
      prop: "createUserName",
      minWidth: "100",
    }, {
      label: "操作",
      fixed: "right",
      with: "40",
      render: vo => <Deal vo={vo} />
    }
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
